module.exports = __webpack_public_path__ + "static/media/dz.cd764f68.svg";